import { z } from 'zod';
import { baseProfessionSchema } from './IBaseProfession';
import { dateField } from '../schemas/common.schemas';

// Schemas (source of truth) — dateField accepts both Date and ISO string, outputs Date
export const professionSchema = baseProfessionSchema.extend({
	_id: z.string(),
	dateDeleted: dateField.optional(),
	dateCreated: dateField,
});

// Types (derived from schemas)
export type IProfession = z.infer<typeof professionSchema>;
